/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=2b598357&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2b598357&lang=sass&scoped=true"

import exportComponent from "/Users/boringtu/Workspace/pri/kangxt-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b598357"]])

export default __exports__